import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const COOKIE_CONSENT_KEY = "euronova_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { lang } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 3000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "declined");
    setVisible(false);
  };

  if (!visible) return null;

  const text = lang === "ro"
    ? {
        title: "Politica de cookies",
        message: "Acest site folosește cookies pentru a îmbunătăți experiența de navigare. Prin continuarea utilizării site-ului, sunteți de acord cu ",
        link: "Politica noastră de cookies",
        accept: "Accept",
        decline: "Refuz",
      }
    : {
        title: "Cookie Policy",
        message: "This website uses cookies to improve your browsing experience. By continuing to use the site, you agree to our ",
        link: "Cookie Policy",
        accept: "Accept",
        decline: "Decline",
      };

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center p-4 bg-black/40 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="relative w-full max-w-lg bg-background border border-border rounded-2xl shadow-2xl p-6 sm:p-8 animate-in slide-in-from-bottom-4 duration-500">
        <button
          onClick={decline}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        <h3
          className="text-lg font-bold text-foreground mb-3"
          style={{ fontFamily: "'Montserrat', sans-serif" }}
        >
          🍪 {text.title}
        </h3>

        <p className="text-sm text-muted-foreground leading-relaxed mb-5">
          {text.message}
          <Link
            to="/politica-cookies"
            className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors"
          >
            {text.link}
          </Link>
          .
        </p>

        <div className="flex items-center gap-3">
          <button
            onClick={accept}
            className="flex-1 bg-gradient-brand px-5 py-2.5 rounded-lg text-sm font-semibold text-primary-foreground hover:opacity-90 transition-opacity"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {text.accept}
          </button>
          <button
            onClick={decline}
            className="flex-1 px-5 py-2.5 rounded-lg text-sm font-semibold border border-border text-foreground hover:bg-muted transition-colors"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {text.decline}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
